import { useState } from 'react';
import { useAuth } from '@/lib/store';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { login } from '@/lib/api/auth';
import { useTheme } from '@/components/theme/ThemeProvider';
import logoLight from '@/img/Logo.svg';
import logoDark from '@/img/LogoDark.svg';

export function LoginForm() {
  const loginAuth = useAuth((state) => state.login);
  const { theme } = useTheme();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const token = await login(username, password);
      loginAuth(token, username);
    } catch (err) {
      setError('Invalid credentials');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center gap-2">
      <div className="flex h-12 w-12 items-center justify-center">
        <img 
          src={theme === 'dark' ? logoDark : logoLight} 
          alt="Logo" 
          className="h-full w-full"
        />
      </div>
      <h2 className="font-ibm-condensed text-2xl font-semibold dark:text-white">
        Pax Intelligence
      </h2>
      <p className="text-sm text-gray-500 dark:text-gray-400">
        Sign in to your account
      </p>

      <form onSubmit={handleSubmit} className="mt-6 space-y-6 w-full">
        <div className="space-y-2">
          <Label htmlFor="username">Username</Label>
          <Input
            id="username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="password">Password</Label>
          <Input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        {error && (
          <div className="text-sm text-red-500 dark:text-red-400">
            {error}
          </div>
        )}

        <Button
          type="submit"
          className="w-full"
          disabled={isLoading}
        >
          {isLoading ? 'Signing in...' : 'Sign in'}
        </Button>
      </form>
    </div>
  );
}